import { render, staticRenderFns } from "./data-management.vue?vue&type=template&id=fb9fafc6&scoped=true"
import script from "./data-management.vue?vue&type=script&lang=ts"
export * from "./data-management.vue?vue&type=script&lang=ts"
import style0 from "./data-management.vue?vue&type=style&index=0&id=fb9fafc6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9fafc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb9fafc6')) {
      api.createRecord('fb9fafc6', component.options)
    } else {
      api.reload('fb9fafc6', component.options)
    }
    module.hot.accept("./data-management.vue?vue&type=template&id=fb9fafc6&scoped=true", function () {
      api.rerender('fb9fafc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-management/data-management.vue"
export default component.exports